<script>
import Layout from "../../layouts/main";
import appConfig from "../../../app.config";
// import PageHeader from "@/components/page-header";
import uploadAvatar from "@/views/widgets/upload-files/upload-avatar";
import {CUSTOMER_INDUSTRY_LIST, CUSTOME_ATTR_LIST, COMPANY_SIZE_TXT, COMPANY_SIZE} from "@/config/common";
import {
  successMsg,
  alertError
} from "@/helpers/swal";
import {useVuelidate} from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import LocationSelect from "@/views/widgets/location-select";
import {userProfile, patchUserProfile,
  // authStatus
} from "@/service";
import i18n from "@/i18n";
export default {
  setup: () => ({ v$: useVuelidate() }),
  page: {
    title: i18n.global.t('page.personal-information.text'),
    meta: [{
      name: "description",
      content: appConfig.description,
    },],
  },
  data() {
    return {
      CUSTOME_ATTR_LIST,
      INDUSTRY: CUSTOMER_INDUSTRY_LIST,
      COMPANY_SIZE_TXT,
      COMPANY_SIZE,
      title: this.$t('page.personal-information.text'),
      checkTabVal: '1',
      tabOptions: [
        {
          value: '1',
          text: this.$t('page.personal-information.ChangePassword')
        },
      ],
      detail: {
        logo: null,
        department: '',
        position: '',
        tel: '',
        email: '',
        country: '',
        province: '',
        city: '',
        address: '',
        // user: {
        //   first_name: '',
        //   last_name: '',
        // }
      },
      addressTxt: '',
      userInfo: {},
      infoEditing: false,
      changePwdForm: {
        oldPwd: '',
        newPwd: '',
        confirmPwd: '',
      }
    };
  },
  validations: {
    changePwdForm: {
      oldPwd: { required },
      newPwd: { required },
      confirmPwd: { required },
    }
  },
  components: {
    Layout,
    // PageHeader,
    uploadAvatar,
    LocationSelect,
  },
  computed: {

  },
  watch: {
  },
  mounted() {
    this.getDetail()
  },

  methods: {
    getDetail() {
      userProfile().then(res => {
        const profile = res.payload.results[0]
        for (let key in this.detail) {
          if (key != 'user') {
            this.detail[key] = profile[key]
          }
        }
        this.addressTxt = ""
        if (profile.country_txt) this.addressTxt += profile.country_txt
        if (profile.province_txt) this.addressTxt += profile.province_txt
        if (profile.city_txt) this.addressTxt += profile.city_txt
        if (profile.address) this.addressTxt += profile.address

        // this.addressTxt = `${profile.country_txt}${profile.province_txt}${profile.city_txt}${profile.address}`
        // 从本地的用户信息里获取user的信息
        const user = JSON.parse(localStorage.getItem('user'))
        this.userInfo = {
          first_name: user.first_name,
          last_name: user.last_name
        }
        this.detail.id = profile.id
        console.log('detail:', this.detail)
      })
    },
    editInfo() {
      this.infoEditing = true
    },
    // 修改选择地区后
    locationSelected(selected) {
      if (selected) {
        this.detail.country = parseInt(selected[0])
        this.detail.province = parseInt(selected[1])
        this.detail.city = parseInt(selected[2])
      } else {
        this.detail.country = null
        this.detail.province = null
        this.detail.city = null
      }
    },
    saveInfo() {
      patchUserProfile(this.detail).then(() => {
        successMsg(this.$t('base.modified_successfully'))
        // authStatus()
        this.getDetail()
        if (this.detail.logo) {
          let user = JSON.parse(localStorage.getItem('user'));
          if (user && user.profile) {
            user.profile.logo = this.detail.logo
            localStorage.setItem('user', JSON.stringify(user))
          }
        }
        this.infoEditing = false
      }).catch(err => {
        console.log(err)
        alertError(this.$t('base.prompt'), this.$t('manufacturer.error'))
      })
    }
  },
};
</script>

<template>
  <Layout>
<!--    <PageHeader :title="title" :items="items" />-->
    <b-row align-v="stretch">
      <b-col cols="4"></b-col>
      <b-col cols="4">
        <b-card no-body class="mb-0">
          <b-card-body class="p-4">
            <div>
              <div class="d-flex justify-content-end btns-wrapper">
                <div v-if="!infoEditing" class="avatar-sm circle-btn" @click="editInfo">
                  <div class="avatar-title rounded-circle bg-body text-primary cursor-pointer">
                    <i class="ri-edit-2-line"></i>
                  </div>
                </div>
              </div>
              <div class="flex-shrink-0 avatar-md mx-auto mt-3">
                <upload-avatar :value="detail.logo" :upload-disable="!infoEditing" v-model="detail.logo" input-id="uploadLogo" filename-prefix="account" return-type="url"></upload-avatar>
              </div>
              <div class="table-responsive">
                <table class="table mb-0 table-borderless">
                  <tbody>
                  <tr>
                    <th :class="!infoEditing?'min-w-90':''"><span class="fw-medium">{{this.$t('page.user.name')}}</span></th>
                    <td>
                      <span>{{ userInfo.first_name }} {{ userInfo.last_name }}</span>
<!--                      <span v-if="!infoEditing">{{ detail.user.first_name }} {{ detail.user.last_name }}</span>-->
<!--                      <div v-else class="d-flex justify-content-between">-->
<!--                        <input type="text" class="form-control me-2" placeholder="" v-model="detail.user.first_name" />-->
<!--                        <input type="text" class="form-control me-2" placeholder="" v-model="detail.user.last_name" />-->
<!--                      </div>-->
                    </td>
                  </tr>
                  <tr>
                    <th><span class="fw-medium">{{this.$t('page.user.contact number')}}</span></th>
                    <td>
                      <span>{{ detail.tel }}</span>
<!--                      <span v-if="!infoEditing">{{ detail.tel }}</span>-->
<!--                      <input v-else type="text" class="form-control" v-model="detail.tel" />-->
                    </td>
                  </tr>
                  <tr>
                    <th><span class="fw-medium">{{this.$t('page.user.email')}}</span></th>
                    <td>
                      <span>{{ detail.email }}</span>
<!--                      <span v-if="!infoEditing">{{ detail.email }}</span>-->
<!--                      <input v-else type="text" class="form-control" v-model="detail.email" />-->
                    </td>
                  </tr>
                  <tr>
                    <th :class="!infoEditing?'min-w-90':''"><span class="fw-medium">{{this.$t('page.user.department')}}</span></th>
                    <td>
                      <span v-if="!infoEditing">{{ detail.department }}</span>
                      <input v-else type="text" class="form-control" v-model="detail.department" />
                    </td>
                  </tr>
                  <tr>
                    <th><span class="fw-medium">{{this.$t('page.user.post')}}</span></th>
                    <td>
                      <span v-if="!infoEditing">{{ detail.position }}</span>
                      <input v-else type="text" class="form-control" v-model="detail.position" />
                    </td>
                  </tr>

                  <tr>
                    <th><span class="fw-medium">{{this.$t('page.user.contact_address')}}</span></th>
                    <td>
                      <span v-if="!infoEditing">{{ addressTxt }}</span>
                      <template v-else>
                        <location-select
                            :selected-location="[parseInt(detail.country), parseInt(detail.province), parseInt(detail.city)]"
                            @selected="locationSelected"
                        ></location-select>
                        <textarea type="text" class="form-control" v-model="detail.address" />
                      </template>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="text-end" v-if="infoEditing">
                <button class="btn btn-outline-primary me-3" @click="infoEditing = false">{{this.$t('base.cancel')}}</button>
                <button class="btn btn-primary" @click="saveInfo">{{this.$t('base.done')}}</button>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="8" v-if="false">
        <b-card no-body class="mb-0 border-bottom">
          <b-card-header class="border-0">
            <ul class="nav nav-tabs-custom card-header-tabs border-bottom-0" role="tablist">
              <li class="nav-item" v-for="(item, index) in tabOptions" :key="index" @click="checkTabVal = item.value">
                <b-link class="nav-link fw-semibold" :class="checkTabVal == item.value ? 'active' : ''" role="tab">
                  {{ item.text }}
                </b-link>
              </li>
            </ul>
          </b-card-header>
          <b-card-body>
            <div class="tab-content">
              <div class="tab-pane active" role="tabpanel" v-show="checkTabVal == 1">
                <div class="mb-3">
                  <label class="form-label" for="meta-title-input">{{this.$t('page.user.CurrentPassword')}}<span class="text-danger">{{this.$t('serviceCompany.not_null')}}</span></label>
                  <input type="password" class="form-control" :class="v$.changePwdForm.oldPwd.$errors.length ? 'is-invalid' : ''" v-model.trim="changePwdForm.oldPwd" @blur="v$.changePwdForm.oldPwd.$touch()" required />
                </div>
                <div class="mb-3">
                  <label class="form-label" for="meta-title-input">{{this.$t('page.user.NewPassword')}}<span class="text-danger">{{this.$t('serviceCompany.not_null')}}</span></label>
                  <input type="password" class="form-control" :class="v$.changePwdForm.newPwd.$errors.length ? 'is-invalid' : ''" v-model.trim="changePwdForm.newPwd" @blur="v$.changePwdForm.newPwd.$touch()" required />
                </div>
                <div class="mb-3">
                  <label class="form-label" for="meta-title-input">{{this.$t('page.user.ConfirmPassword')}}<span class="text-danger">{{this.$t('serviceCompany.not_null')}}</span></label>
                  <input type="password" class="form-control" :class="v$.changePwdForm.confirmPwd.$errors.length ? 'is-invalid' : ''" v-model.trim="changePwdForm.confirmPwd" @blur="v$.changePwdForm.confirmPwd.$touch()" required />
                </div>
                <div class="d-flex justify-content-end">
                  <button class="btn btn-outline-primary me-3">{{this.$t('base.cancel')}}</button>
                  <button class="btn btn-primary">{{this.$t('base.done')}}</button>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </Layout>

</template>
<style scoped>
.btns-wrapper {
  position: absolute;
  top: 10px;
  right: 10px;
}
.circle-btn {
  width: 2.5rem;
  height: 2.5rem;
  font-size: 1.4rem;
}
</style>
